import React, { useEffect, useState, useCallback } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha } from "@mui/material";
import theme from "src/config/theme";
import ButtonComponent from "src/components/shared/Button";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Delete } from '../../../../../assets/images/trash.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import { ReactComponent as View } from '../../../../../assets/images/eye.svg';
import { ReactComponent as Download } from '../../../../../assets/images/document-download.svg'
import ReportTabForm from "../Forms/ReportTabForm";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import useResponsive from "src/components/hooks/useResponsive";
import { getReportsByPatientIdRequest, getViewReportByIdRequest, getDownloadReportByIdRequest } from "src/modules/app/store/appActions";
import useAppointmentDetails from "../../UseAppointmentDetails";
import { AllTabsMainContainer } from "../Style";
import ReportCard from "../CardView/ReportCard";
const columns = [
  { id: "reports", label: "Reports", sx: { width: "320px", minWidth: "150px", textAlign: 'left' } },
  { id: "reportName", label: "Report Name", sx: { width: "2000px", textAlign: 'left' }, },
  // { id: "addedDate", label: "Added Date", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
];

const Reports = ({ shouldRefresh }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [report, setReport] = useState([]);
  const { PatientId } = useAppointmentDetails();
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();

  const { isMobile, isTablet, isDesktop } = useResponsive();



  const fetchReports = useCallback(
    (page = 0, perPage = 10) => {
      const fetchData = async () => {
        const params = {
          page: page + 1,
          limit: perPage,
        };

        try {
          const response = await new Promise((resolve, reject) => {
            dispatch(getReportsByPatientIdRequest({ patientId: PatientId, params }, resolve, reject));
          });

          if (response?.data) {
            setReport(response.data);
            setTotalCount(response.meta?.totalRecords || 0);
          } else {
            setReport([]);
            setTotalCount(0);
          }
        } catch (err) {
          if (err?.message?.includes('No files found')) {
            setReport([]);
            setTotalCount(0);
          } else {
            console.error('Unhandled error in report fetch:', err);
          }
        }

      }
      fetchData();

    },
    [dispatch, PatientId],
  );
  useEffect(() => {
    if (PatientId) {
      fetchReports(page, perPage);
    }
  }, [PatientId, fetchReports, page, perPage, shouldRefresh]);

  const data = report.map((reportData) => ({
    reportId: reportData.id,
    reports: reportData.typesOfReports,
    reportName: reportData.filename,
    contentType: reportData.contentType,
    // addedDate: '15th Oct, 10:00am',
  }))
  const handleViewReport = async (reportId, contentType, reportName) => {
    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(getViewReportByIdRequest(reportId, resolve, reject));
      });
      console.log("here is response", response);
      if (response) {
        const blob = new Blob([response], { type: contentType });
        const blobUrl = window.URL.createObjectURL(blob);
        console.log("Opening new tab with URL:", blobUrl);
        window.open(blobUrl, '_blank');
      }
    } catch (error) {
      console.error("Error viewing report:", error);
    }
  };

  const handleDownloadReport = async (reportId, contentType, reportName) => {
    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(getDownloadReportByIdRequest(reportId, resolve, reject));
      });

      if (response) {
        const blob = new Blob([response], { type: contentType });
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        const fileExtension = contentType.split('/')[1];
        const fileName = `report-${reportName}.${fileExtension}`;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error('No file data received for download.');
      }
    } catch (error) {
      console.error('Error during download:', error);
    }
  };
  const actions = [
    { label: "View", icon: <View />, onClick: (row) => handleViewReport(row.reportId, row.contentType) },
    { label: "Download", icon: <Download />, onClick: (row) => handleDownloadReport(row.reportId, row.contentType, row.reportName) },
  ];

  return (
    <>
      <AllTabsMainContainer>
        {(isMobile || isTablet) ?
          <ReportCard
            report={report}
            page={page}
            perPage={perPage}
            setPage={setPage}
            totalCount={totalCount}
            fetchReports={fetchReports}
            handleViewReport={handleViewReport}
            handleDownloadReport={handleDownloadReport}
          /> :
          <CustomTable
            key={page}
            columns={columns}
            data={data}
            actions={actions}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            headerButton={
              <ButtonComponent
                variant="contained"
                endIcon={<Add width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} />}
                onClick={handleOpen}
                sx={{
                  background: theme.palette.primary.main,
                  border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                  boxShadow: theme.shadows[1],
                  minWidth: '137px',
                  height: '36px',
                  padding: '6px 6px 6px 10px',
                  borderRadius: '12px',
                  ...theme.typography.h5,
                }}
              >Add Report</ButtonComponent>
            }
            noDataComponent={
              <NoDataFound
                title="No Reports Found!"
                buttonText="Add Report"
                buttonIcon={Add}
                onClick={handleOpen}
              />
            }
          />
        }
        <DialogBox open={open} onClose={handleClose} title="Add Report">
          <ReportTabForm onClose={handleClose} fetchReports={fetchReports} />
        </DialogBox>
      </AllTabsMainContainer>
    </>
  )
};
export default Reports;

